import * as React from 'react';
import IconButton from '../common/IconButton';
import { Dispatch, Action } from 'redux';
import {
  clearEverything,
  clearAllObjects,
  clearAllHandwriting,
  clearAllLearningPenRects,
} from '../../drawing/actions/DrawingAction';
import { IntegratedDrawingState } from '../../reducers/integratedDrawing';
import ToolIconButton from '../common/ToolIconButton';

interface AllErasingButtonsProps {
  readonly dispatch: Dispatch<Action>;
  readonly integratedDrawing: IntegratedDrawingState;
}

const confirmClearAllLearningPenRects = (dispatch: Dispatch<Action>) => {
  if (!window.confirm('このページの暗記ペン書き込みをすべて削除します。本当によろしいですか？')) {
    return;
  }
  dispatch(clearAllLearningPenRects());
};

const confirmClearAllObjects = (dispatch: Dispatch<Action>) => {
  if (!window.confirm('このページのオブジェクト書き込みをすべて削除します。本当によろしいですか？')) {
    return;
  }
  dispatch(clearAllObjects());
};

const confirmClearAllHandwriting = (dispatch: Dispatch<Action>) => {
  if (window.confirm('このページのペン書き込みをすべて削除します。本当によろしいですか？')) {
    dispatch(clearAllHandwriting());
  }
};

const confirmClearEverything = (dispatch: Dispatch<Action>) => {
  if (window.confirm('このページの書き込みをすべて削除します。本当によろしいですか？')) {
    dispatch(clearEverything());
  }
};

const AllErasingButtons: React.SFC<AllErasingButtonsProps> = React.memo((props) => {
  const { dispatch } = props;

  return (
    <>
      <ToolIconButton
        text="暗記ペン全削除"
        margin={false}
        onClick={() => confirmClearAllLearningPenRects(dispatch)}
      />
      <IconButton
        title="オブジェクト全消去"
        imagePath="images/tool-icons/new/object_erase/object_erase"
        onClick={() => confirmClearAllObjects(dispatch)} />
      <IconButton
        title="フリーハンド全消去"
        imagePath="images/tool-icons/new/bitmap_erase/bitmap_erase"
        onClick={() => confirmClearAllHandwriting(dispatch)} />
      <IconButton
        title="完全消去"
        imagePath="images/tool-icons/new/all_erase/all_erase"
        onClick={() => confirmClearEverything(dispatch)} />
    </>
  );
});

export default AllErasingButtons;
